// update descblock input
// update descblock response
// update traveller info
// update pc
// update profile type
// update gocash usage
// make provisional booking
// init payment

import {
  UPDATE_DESCBLOCK_DATA,
  UPDATE_DESCBLOCK_INPUT,
  UPDATE_TRAVELLER_DETAILS,
  UPDATE_HOTELS_PAYMENTS_DATA,
  UPDATE_HOTELS_PAYMENT_OPEN_CLOSE_STATUS,
  UPDATE_USEGOCASH_STATUS,
  RESET_PAYMENTS_DATA,
  UPDATE_DESCBLOCK_LOADING_STATUS,
  UPDATE_EARLYCHECKIN_STATUS,
  UPDATE_COUNTRY_CODES,
  UPDATE_HOTELS_POLICY,
  UPDATE_USER_VERIFICATION,
  UPDATE_DESCBLOCK_INPUT_FWD
} from './constants';
import {
  IUpdateDescBlockData,
  IUpdateTravellerDetails,
  IUpdateProfileType,
  IUpdatePaymentsData,
  IUpdatePaymentModuleOpenClose,
  IUpdateUseGoCash,
  IResetPaymentsData,
  IUpdateDescblockLoadingStatus,
  IUpdateEarlyCheckinStatus,
} from './hotels-review-types';

export function updateDescblockData(
  actionData: IUpdateDescBlockData['actionData'],
): IUpdateDescBlockData {
  return {
    type: UPDATE_DESCBLOCK_DATA,
    actionData,
  };
}

export function updateDescblockInput(
  actionData: IUpdateDescBlockData['actionData'],
): IUpdateDescBlockData {
  return {
    type: UPDATE_DESCBLOCK_INPUT,
    actionData,
  };
}

export function updateDeskblockInputFwd(
  actionData: IUpdateDescBlockData['actionData'],
): IUpdateDescBlockData {
  return {
    type: UPDATE_DESCBLOCK_INPUT_FWD,
    actionData,
  };
}

export function updateTravellerDetails(actionData: any): IUpdateTravellerDetails {
  return {
    type: UPDATE_TRAVELLER_DETAILS,
    actionData,
  };
}

export function toggleBusinessProfile(value: boolean): IUpdateProfileType {
  return {
    type: UPDATE_TRAVELLER_DETAILS,
    actionData: {businessProfile: value},
  };
}

export function updatePaymentsData(actionData: any): IUpdatePaymentsData {
  return {
    type: UPDATE_HOTELS_PAYMENTS_DATA,
    actionData,
  };
}

export function closePaymentModule(): IUpdatePaymentModuleOpenClose {
  return {
    type: UPDATE_HOTELS_PAYMENT_OPEN_CLOSE_STATUS,
    status: false,
  };
}

export function resetPaymentsData(): IResetPaymentsData {
  return {
    type: RESET_PAYMENTS_DATA,
  };
}

export function openPaymentModule(): IUpdatePaymentModuleOpenClose {
  return {
    type: UPDATE_HOTELS_PAYMENT_OPEN_CLOSE_STATUS,
    status: true,
  };
}

export function setDescblockLoading(value: boolean): IUpdateDescblockLoadingStatus {
  return {
    type: UPDATE_DESCBLOCK_LOADING_STATUS,
    status: value,
  };
}

export function updateEarlyCheckInStatus(value: boolean): IUpdateEarlyCheckinStatus {
  return {
    type: UPDATE_EARLYCHECKIN_STATUS,
    status: value,
  };
}

export function updateCountryCodes(actionData) {
  return {
    type: UPDATE_COUNTRY_CODES,
    actionData,
  };
}

export function updateHotelsPolicy(actionData) {
  return {
    type: UPDATE_HOTELS_POLICY,
    actionData,
  };
}

export function updateUserVerification(userVerified) {
  return {
    type: UPDATE_USER_VERIFICATION,
    actionData: {
      userVerified,
      otpVerificationDone: true
    }
  };
}
